import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import ResultSplat from './ResultSplat';
import ResultsBubbles from './ResultsBubbles';
import { IAppState } from '../db/reducers';

const SResultsCanvas = styled.div`
  display: flex;
  height: inherit;
  width: inherit;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 768px) {
    height: 40vh;
  }
`;

const SResultsText = styled.p`
  display: flex;
  font-size: 2em;
  margin: 0 0 0 0;
  align-self: center;
  text-align: center;
`;

interface IResultsCanvasParams {
  pollId: string;
}

interface IResultsCanvasProps {
  polls: any;
  resultsViewIsBubbles: boolean;
}

const ResultsCanvas: React.SFC<IResultsCanvasProps> = (props) => {
  const { polls, resultsViewIsBubbles } = props;
  const { pollId } = (useParams() as unknown) as IResultsCanvasParams;

  return (
    <SResultsCanvas className='SResultsCanvas'>
      {!polls[pollId].scores && (
        <SResultsText>Waiting for scores...</SResultsText>
      )}
      {polls[pollId].scores &&
        !resultsViewIsBubbles &&
        Object.keys(polls[pollId].scores).map((key: string, idx: number) => (
          <ResultSplat key={idx} splatScore={polls[pollId].scores[key]} />
        ))}
      {polls[pollId].scores && resultsViewIsBubbles && (
        <ResultsBubbles scores={polls[pollId].scores} />
      )}
    </SResultsCanvas>
  );
};

const mapStateToProps = (state: IAppState) => {
  return {
    polls: state.polls,
    resultsViewIsBubbles: state.resultsViewIsBubbles,
  };
};

export default connect(mapStateToProps)(ResultsCanvas);
